<template>
    <q-input
    outlined
    square
    color="secondary"
    type="text"
    required
    v-model="addressModel"
    class="autocomplete-adress"
    minlength="3"
    :label="label"
    ref="autocomplete"
    :hint="hint"
    lazy-rules
    />
</template>

<script>
import { ref } from '@vue/reactivity';
import { watch } from '@vue/runtime-core';
// Add google map script if not exist; if already exist, return true
window.checkAndAttachMapScript = function (callback) {
  let scriptId = "map-api-script";
  let mapAlreadyAttached = !!document.getElementById(scriptId);

  if (mapAlreadyAttached) {
    if (window.google) // Script attached but may not finished loading; so check for 'google' object.
      callback();
  } else {
    window.mapApiInitialized = callback;

    let script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_MAPS_KEY}&libraries=places,geometry&callback=mapApiInitialized`;
    document.body.appendChild(script);
  }

  return mapAlreadyAttached;
}

export default {
    props: ['hint', 'rules', 'address', 'label'],
    setup(props, context) {    
        const autocompleteA = ref(null)
        const autocomplete = ref(null)
        const addressModel = ref(props.address)
        const label = (props.label) ? props.label : ref('City')
        const rules = (props.rules) ? ref(props.rules) : ref([])
      
        watch(autocomplete, (autocomplete, oldAutocomplete) => {
            if (autocomplete && !oldAutocomplete) window.checkAndAttachMapScript(autocompleteInit)
        })

        const autocompleteInit = () => {
            autocompleteA.value = new google.maps.places.Autocomplete(
                (autocomplete.value.getNativeElement()),
                {types: ['geocode']}
            );

            autocompleteA.value.addListener('place_changed', () => {
                let place = autocompleteA.value.getPlace();
                addressModel.value = place.formatted_address
                context.emit('place', place)
            });
        }

        return { addressModel, rules, autocomplete, autocompleteA, label}
    },
}
</script>
